import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import styled from "styled-components";

const StyledFormControl = styled(Form.Control)`
  background-image: none !important;
`;

interface ValidatingPasswordInputProps {
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  value: string;
  error?: string;
  touched?: boolean;
  label?: string;
  name?: string;
}

const ValidatingPasswordInput = ({
  handleChange,
  handleBlur,
  value,
  error,
  touched,
  label,
  name,
}: ValidatingPasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Form.Group className="mb-3">
      <Form.Label className="mb-0">{label}</Form.Label>
      <div className="position-relative">
        <StyledFormControl
          type={showPassword ? "text" : "password"}
          onChange={handleChange}
          value={value}
          isInvalid={touched && !!error}
          onBlur={handleBlur}
          name={name}
        />
        <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
        <div
          className="position-absolute border-0"
          style={{ cursor: "pointer", zIndex: 10, right: 10, top: 7 }}
          onClick={() => setShowPassword(!showPassword)}
        >
          <FontAwesomeIcon
            className="text-primary"
            icon={showPassword ? faEyeSlash : faEye}
          />
        </div>
      </div>
    </Form.Group>
  );
};

export default ValidatingPasswordInput;
